// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__h1OS4","rotator":"loader_rotator__OTpT-","path":"loader_path__csLA1","dash":"loader_dash__yX-ek"};